import React from "react";
import aboutVideo from "../../assets/videos/video-main.mp4";
import TitleComponent from "../common/TitleComponent";
import WellnessLogo from "../../assets/images/Logos/wellness-flw-2.png";
import { Link } from "react-router";
import carepointImage1 from "../../assets/images/wellnesscarepoint/gal-3.png";
import carepointImage3 from "../../assets/images/Decorations/blueLotus.png";

import { motion } from "framer-motion";
import { fadeIn } from "../animation/Variants";

const HomeAboutUsContent = () => {
  return (
    <>
      <div className=" px-6 my-3 mb-16">
        <div className="mb-6">
          <TitleComponent
            Title={"About Us"}
            Subtitle={
              "Embark on a transformative journey at ceylon wellness Ayurveda, where personalized care blends the ancient wisdom of Ayurveda withSri Lanka's Hela Wedakama to rejuvenate and restore balance to your mind and body."
            }
          />
        </div>
        <div className="flex flex-col-reverse lg:flex-row shadow-md ">
          <div className="w-full xl:w-1/2 px-6 bg-customBrass-90">
            <div className="flex flex-col w-full  text-black gap-4">
             
              {/* <div className="flex justify-around">
                       <img
                         src={carepointImage3}
                         alt="image 2"
                         className="absolute z-10 object-cover h-48 w-48"
                       />
                     </div> */}
             
             
             
              <motion.div
                variants={fadeIn("up", 0.4)}
                initial="hidden"
                whileInView={"show"}
                viewport={{ once: false, amount: 0.7 }}
                aria-hidden="true"
                className=" p-6  mb-4"
              >
                <div className="flex justify-center mb-4">
                  <img
                    src={WellnessLogo}
                    alt="image 2"
                    className="h-10 w-25 full object-cover"
                  />
                </div>
                <h2 className="text-customMaroon-35 text-center text-xl lg:text-3xl font-bold mb-2 title_DMSerifText-Regular uppercase">
                  A Legacy of Compassionate Care!
                </h2>

                <p className="leading-relaxed text-sm lg:text-base description_AlegreyaSans-Light">
                  Ceylon Hospital is a trusted Ayurvedic healthcare center,
                  known for its expertise in natural and holistic healing. With
                  a focus on traditional Ayurvedic principles, the hospital
                  offers treatments that address the root causes of various
                  health conditions. Combining herbal remedies, therapeutic
                  practices, and personalized care, Ceylon Hospital has earned a
                  reputation for successful outcomes in managing chronic
                  ailments such as joint pain, digestive issues, stress, and
                  skin disorders. <br /> <br /> The hospital’s skilled team of
                  Ayurvedic practitioners ensures that each patient receives
                  tailored treatment plans designed to promote overall
                  well-being and restore balance. By blending ancient wisdom
                  with modern healthcare practices, Ceylon Hospital provides
                  safe, effective, and natural solutions for a healthier
                  lifestyle. <br /> <br />
                  Ceylon Hospital is more than just a place of treatment—it is a
                  haven for holistic rejuvenation. Its dedication to patient
                  care and its track record of successful treatments make it a
                  leading choice for those seeking natural and lasting wellness.
                </p>
                <div className="flex justify-center">
                  <Link to={"/AboutUs"}>
                    <div className="flex normal_link slick_title mt-4">
                      <h6 className="font-bold  text_PlayfairDisplay-VariableFont_wght uppercase text-sm">
                        Read more..
                      </h6>
                    </div>
                  </Link>
                </div>
              </motion.div>

              <div className="flex flex-col md:flex-row gap-4">
                <motion.div
                  variants={fadeIn("right", 0.4)}
                  initial="hidden"
                  whileInView={"show"}
                  viewport={{ once: false, amount: 0.7 }}
                  aria-hidden="true"
                  className="w-full md:w-1/2  p-4 rounded-sm "
                >
                  <p className="text-customMaroon-35 font-bold text-lg title_DMSerifText-Regular uppercase">
                    Our Mission
                  </p>
                  <p className="text-sm leading-relaxed description_AlegreyaSans-Light">
                    To provide holistic healthcare rooted in the ancient wisdom
                    of Ayurveda, offering natural and personalized treatments
                    that restore balance, promote well-being, and enhance the
                    quality of life for all individuals.
                  </p>
                </motion.div>
                <motion.div
                  variants={fadeIn("left", 0.4)}
                  initial="hidden"
                  whileInView={"show"}
                  viewport={{ once: false, amount: 0.7 }}
                  aria-hidden="true"
                  className="w-full md:w-1/2  p-4 rounded-sm "
                >
                  <p className="text-customMaroon-35 font-bold text-lg title_DMSerifText-Regular uppercase">
                    Our Vision
                  </p>
                  <p className="text-sm leading-relaxed description_AlegreyaSans-Light">
                    To be a globally recognized leader in Ayurvedic healthcare,
                    setting the standard for natural healing by combining
                    traditional knowledge with modern practices, fostering a
                    healthier and more balanced world.
                  </p>
                </motion.div>
              </div>
            </div>
          </div>
          <div className="w-full xl:w-1/2 bg-customMaroon-25">
            <div className="w-full px-2 py-5 flex flex-col gap-3 items-center">
             <p className="text-white text_CormorantGaramond-Regular uppercase text-center text-2xl">Ayurveda & Hela Wedakama</p>

              <div className="w-full ">
                {/* vedio */}
                <div className="flex w-full   rounded-l-sm">
                  <div className="w-full h-64 md:h-80 lg:h-full overflow-hidden rounded-sm shadow-lg">
                    <video
                      autoPlay
                      loop
                      muted
                      playsInline
                      className="object-cover w-full h-full"
                    >
                      <source src={aboutVideo} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                </div>
              </div>

               {/* photos */}
              <div className="px-2  w-full flex flex-row mt-5">
                <div className="w-full xl:w-1/2 z-10">
                 <p className="text-center leading-tight text-white text_CormorantGaramond-Regular uppercase mb-4 italic">Customer friendliness and efficient reliable service. </p>
                  <img
                    src={carepointImage1}
                    alt="image 2"
                    className="h-56 w-full object-cover"
                  />
                  
                </div>
                <div className="w-full xl:w-1/2">
                  <img
                    src={carepointImage1}
                    alt="image 2"
                    className="h-56 w-full object-cover"
                  />
                </div>
          
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="bg-customBrass-90 py-6 my-3 ">
        <div className="rounded-sm px-2 ">
          <div className="flex flex-col-reverse lg:flex-row gap-4 px-4 py-6 ">
            <div className="flex flex-col w-full lg:w-1/2 text-black gap-4">
              <motion.div
                variants={fadeIn("up", 0.4)}
                initial="hidden"
                whileInView={"show"}
                viewport={{ once: false, amount: 0.7 }}
                aria-hidden="true"
                className="bg-white p-6 rounded-sm shadow-lg mb-4"
              >
                <div className="flex justify-center mb-4">
                  <img
                    src={WellnessLogo}
                    alt="image 2"
                    className="h-10 w-25 full object-cover"
                  />
                </div>
                <h2 className="text-customMaroon-35 text-center text-xl lg:text-3xl font-bold mb-2 title_DMSerifText-Regular uppercase">
                  A Legacy of Compassionate Care!
                </h2>

                <p className="leading-relaxed text-sm lg:text-base description_AlegreyaSans-Light">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only five centuries, but
                  also the leap into electronic typesetting, remaining
                  essentially unchanged.
                </p>
                <div className="flex justify-end">
                  <Link to={"/AboutUs"}>
                    <div className="flex normal_link slick_title mt-4">
                      <h6 className="font-bold  text_PlayfairDisplay-VariableFont_wght uppercase text-sm">
                        Read more..
                      </h6>
                    </div>
                  </Link>
                </div>
              </motion.div>

              <div className="flex flex-col md:flex-row gap-4">
                <motion.div
                  variants={fadeIn("right", 0.4)}
                  initial="hidden"
                  whileInView={"show"}
                  viewport={{ once: false, amount: 0.7 }}
                  aria-hidden="true"
                  className="w-full md:w-1/2 bg-white p-4 rounded-sm shadow-lg"
                >
                  <p className="text-customMaroon-35 font-bold text-lg title_DMSerifText-Regular uppercase">
                    Our Mission
                  </p>
                  <p className="text-sm leading-relaxed description_AlegreyaSans-Light">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Vestibulum elit eu vulputate tristique.
                  </p>
                </motion.div>
                <motion.div
                  variants={fadeIn("left", 0.4)}
                  initial="hidden"
                  whileInView={"show"}
                  viewport={{ once: false, amount: 0.7 }}
                  aria-hidden="true"
                  className="w-full md:w-1/2 bg-white p-4 rounded-sm shadow-lg"
                >
                  <p className="text-customMaroon-35 font-bold text-lg title_DMSerifText-Regular uppercase">
                    Our Vision
                  </p>
                  <p className="text-sm leading-relaxed description_AlegreyaSans-Light">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Vestibulum elit eu vulputate tristique.
                  </p>
                </motion.div>
              </div>
            </div>

            <div className="flex bg-customMaroon-25 w-full  xl:w-1/2 rounded-l-sm">
              <div className="w-full h-64 md:h-80 lg:h-full overflow-hidden rounded-sm shadow-lg">
              
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="object-cover w-full h-full"
                >
                  <source src={aboutVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>

          </div>
        </div>
      </div> */}
    </>
  );
};

export default HomeAboutUsContent;
